import { Component, Injector } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { LocalizationClient } from './core/remote-clients/remote-client';
import { LocalizationService } from './core/services/localization.service';
import { LoaderComponent } from './components/loader/loader.component';
import { BaseComponent } from './core/base.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [RouterOutlet, LoaderComponent, AsyncPipe],
    providers: [LocalizationClient, LocalizationService]
})
export class AppComponent extends BaseComponent {
  title = 'qflow-task-angular-site';
  initialized: Promise<boolean> | null = null;

  constructor(
    private readonly _localizationService: LocalizationService,
    injector: Injector
  ) {
    super(injector);
    this.showLoader();
    this.initialized = new Promise(resolve => {
      this._localizationService.initialize().then(() => {
        this.hideLoader();
        resolve(true);
      });
    });
  }
}
